function findTreeItemIndexPath(tree, matcher) {
  let path;
  tree.some((item, index) => {
    if (matcher(item)) {
      path = [index];
      return true;
    } else if (item.items) {
      let subPath = findTreeItemIndexPath(item.items, matcher);
      if (subPath) {
        path = [index, ...subPath];
        return true;
      }
    }
  });
  return path;
}
export { findTreeItemIndexPath as default };